"use client";

import React, { ComponentProps } from "react";
import { Canvas } from "@react-three/fiber";
import { useInView } from "react-intersection-observer";

/**
 * ConditionalCanvas — An optimized Canvas wrapper that manages rendering based on visibility.
 * It switches to "demand" mode when off-screen to save GPU resources.
 */
const ConditionalCanvas: React.FC<ComponentProps<typeof Canvas>> = ({
  children,
  ...props
}) => {
  const { ref, inView } = useInView({
    threshold: 0,
    rootMargin: "200px", // Start rendering slightly before entering viewport
  });

  return (
    <div ref={ref} className="w-full h-full">
      <Canvas
        {...props}
        // Only run the continuous loop when visible
        frameloop={inView ? (props.frameloop || "always") : "demand"}
        // Optimize device pixel ratio for performance
        dpr={props.dpr || [1, 1.5]}
      >
        {children}
      </Canvas>
    </div>
  );
};

export default ConditionalCanvas;
